import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useWindowSize } from '../../hooks/useWindowSize'
import { useCategory } from '../../contexts/CategoryContext'
import { useCart } from '../../contexts/CartContext'
import { AiOutlineWhatsApp } from 'react-icons/ai'
import { Header } from '../Header'
import { Delivery } from './Delivery'
import { Category } from './Category'
import { Products } from './Products'
import { ReiviewCart } from './ReiviewCart'
import { useConfig } from '../../contexts/ConfigContext';
import { SearchInput } from '../Shared/SearchInput'
import { FixedHeader, GobackTitle } from '../Layout/FixedHeader'
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { BsSearch } from "react-icons/bs";
import {
  HomeContainer,
  DeiveryWrapper,
  CategoryProductsContainer,
  AllProducts,
  BetweenGray,
  WhatsappContainer,
  ProductSearchWrapper,
  OneEle,
  SearchedArea,
  SearchBackground
} from './styles'

export const Home = (props) => {

  const { isProductSearched, searchProducts } = props
  const { width } = useWindowSize();
  const [categories] = useCategory();
  const [configState] = useConfig()
  const [, { setCurrentVendor }] = useCart();
  const [catId, setCatId] = useState(null);
  const currentLng = localStorage.getItem('i18nextLng');
  const { t } = useTranslation();
  const [scrolledCatId, setscrolledCatId] = useState('');
  const [searchedText, setSearchedText] = useState('');
  const handleChangeCat = (catId) => {
    setCatId(catId);
    if (catId) setCurrentVendor(catId);
    if (catId === null) {
      document.getElementById('rightContainer').classList.remove("spec-category")
      return
    }
    document.getElementById('rightContainer').classList.add("spec-category");
  }

  const searchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    setSearchedText(searchText)
  }
  const searchBack = () => {
    searchProducts(false)
    setSearchedText('')
    document.getElementById('rightContainer').classList.remove("remove-image");
  }

  useEffect(() => {
    //debugger
    const container = width > 990 ? document.getElementById('homeContainer') : document;
    let topHeight;
    if (width > 990) topHeight = 0;
    if (width > 600 && width <= 990) topHeight = 900;
    if (width <= 600) topHeight = 250;

    const handleScroll = () => {
      const scrollTop = width > 990 ? container.scrollTop : window.pageYOffset;
      categories?.forEach(item => {
        let topPos = document.getElementById(item.id)?.offsetTop + topHeight
        if (Math.abs(scrollTop - topPos) < 73) {
          setscrolledCatId(item.id)
        }
      })
    }

    //if(configState?.configs?.categoryTypeView === 'list' && categories.length) setCatId(parseFloat(categories[0].id));

    container?.addEventListener('scroll', handleScroll)
    return () => container?.removeEventListener('scroll', handleScroll)
  }, [categories, configState?.configs?.categoryTypeView, width])

  return (
    <HomeContainer id="homeContainer">
      {console.log('isProductSearched', isProductSearched)}
      {console.log('catid', catId)}
      {!isProductSearched && ((!catId && configState?.configs?.categoryTypeView === 'grid') || configState?.configs?.categoryTypeView === 'list') && (
        <>
          <Header setCatId={setCatId} />
          <DeiveryWrapper>
            <Delivery />
          </DeiveryWrapper>
          <BetweenGray />
        </>
      )}
      {isProductSearched && (
        <ProductSearchWrapper>
          <FixedHeader>
            {currentLng === 'en'
              ? <FiArrowLeft size="20" onClick={() => searchBack()} />
              : <FiArrowRight size="20" onClick={() => searchBack()} />
            }
            <GobackTitle>{t('Product Search')}</GobackTitle>
          </FixedHeader>
          <OneEle>
            <SearchInput onChange={(e) => searchChange(e)} />
          </OneEle>
          {searchedText === '' && (
            <SearchedArea>
              <SearchBackground>
                <BsSearch size={50} />
              </SearchBackground>
            </SearchedArea>
          )}

        </ProductSearchWrapper>
      )}

      {configState?.configs?.categoryTypeView === 'list' && (
        <>
          {!isProductSearched && (
            <>
              <Category handleChangeCat={handleChangeCat} catId={catId} scrolledCatId={scrolledCatId} />
              <CategoryProductsContainer>
                {!catId && !isProductSearched && categories.map(
                  (category, index) => (
                  
                      <AllProducts isNotProductSearched={!isProductSearched} key={index}>
                        <Products
                          catId={category.id}
                          searchedText={searchedText}
                          handleChangeCat={handleChangeCat}
                          isProductSearched={isProductSearched}
                        />
                      </AllProducts>
                  )
                )}
                {catId && !isProductSearched && (
                    <AllProducts isNotProductSearched={isProductSearched}>
                      <Products
                        catId={catId}
                        searchedText={searchedText}
                        handleChangeCat={handleChangeCat}
                        isProductSearched={isProductSearched}
                      />
                    </AllProducts>
                )}
               </CategoryProductsContainer>
            </>
          )}
          {(searchedText !== '' && isProductSearched) && (
            <AllProducts isNotProductSearched={!isProductSearched}>
              <Products
                catId={catId}
                searchedText={searchedText}
                handleChangeCat={handleChangeCat}
                isProductSearched={isProductSearched}
              />
            </AllProducts>
          )}
          
        </>
      )}

      {configState?.configs?.categoryTypeView === 'grid' && (
        <>
          {!isProductSearched && (
            <>
              {!catId && (
                <Category handleChangeCat={handleChangeCat} catId={catId} scrolledCatId={scrolledCatId} />
              )}
              {catId && !isProductSearched && (
                  <AllProducts isNotProductSearched={isProductSearched}>
                    <Products
                      catId={catId}
                      searchedText={searchedText}
                      handleChangeCat={handleChangeCat}
                      isProductSearched={isProductSearched}
                    />
                  </AllProducts>
                )}
            </>
          )}
          {(searchedText !== '') && (
             <AllProducts isNotProductSearched={!isProductSearched}>
              <Products
                catId={catId}
                searchedText={searchedText}
                handleChangeCat={handleChangeCat}
                isProductSearched={isProductSearched}
              />
            </AllProducts>
          )}
        </>
      )}

      {/* {!isProductSearched && configState?.configs?.categoryTypeView === 'list' && (
        <Category handleChangeCat={handleChangeCat} catId={catId} scrolledCatId={scrolledCatId} />
      )}
      {(!isProductSearched && !catId) && configState?.configs?.categoryTypeView === 'grid' && (
        <Category handleChangeCat={handleChangeCat} catId={catId} scrolledCatId={scrolledCatId} />
      )}
      {!isProductSearched && configState?.configs?.categoryTypeView === 'list' && (
          <>
          <AllProducts isNotProductSearched={!isProductSearched}>
              <Products
                catId={catId}
                searchedText={searchedText}
                handleChangeCat={handleChangeCat}
                isProductSearched={isProductSearched}
              />
            </AllProducts>
          </>
      )}
       {((searchedText !== '' && isProductSearched)) && configState?.configs?.categoryTypeView === 'list' && (
          <>
          <AllProducts isNotProductSearched={!isProductSearched}>
             fddf <Products
                catId={catId}
                searchedText={searchedText}
                handleChangeCat={handleChangeCat}
                isProductSearched={isProductSearched}
              />
            </AllProducts>
          </>
      )}
   
      {(catId || (searchedText !== '' && isProductSearched)) && configState?.configs?.categoryTypeView === 'grid' && (
        <AllProducts isNotProductSearched={!isProductSearched}  viewType={configState?.configs?.categoryTypeView}>
          <Products
            catId={catId}
            searchedText={searchedText}
            handleChangeCat={handleChangeCat}
            isProductSearched={isProductSearched}
          />
        </AllProducts>
      )} */}
      <ReiviewCart />
      <WhatsappContainer href={configState?.configs?.whatsAppUrl} target="_blank" rel="noreferrer">
        <AiOutlineWhatsApp color="white" size="30" />
      </WhatsappContainer>
    </HomeContainer>
  )
}
